import { ActionColumnFormat } from './ColumnsFormatters/ActionColumnFormat';
import { StatusColumnFormat } from './ColumnsFormatters/StatusColumnFormat';

export const columns = (onDelete, onEditUnit, onStatus) => [
	{
		dataField: 'nombre',
		text: 'Organización',
		headerAlign: 'left',
	},
	{
		dataField: 'prefijo',
		text: 'Prefijo',
		classes: 'text-center',
	},
	{
		dataField: 'estatus',
		text: 'Estatus',
		classes: ' text-center',
		formatter: StatusColumnFormat,
	},
	{
		dataField: 'row',
		text: 'Acciones',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: ActionColumnFormat,
		formatExtraData: {
			onDelete,
			onEditUnit,
			onStatus,
		},
	},
];

export const defaultFilter = {
	organizacion: null,
	prefijo: null,
	estatus: '',
};

export const filterForm = (
	onConfirmFilter,
	onClear,
	institutionsName = [],
	institutionsPre = []
) => [
	{
		label: 'Organización',
		name: 'organizacion',
		type: 'search',
		options: [...institutionsName],
		column: 4,
	},
	{
		label: 'Prefijo',
		name: 'prefijo',
		type: 'search',
		options: [...institutionsPre],
		column: 3,
	},
	{
		label: 'Estatus',
		name: 'estatus',
		type: 'chip-dropdown',
		options: [
			{ value: 'A', text: 'Activo', color: 'primary' },
			{ value: 'I', text: 'Inactivo', color: 'grey' },
		],
		column: 3,
	},
	{
		label: 'Limpiar',
		name: 'Limpiar',
		color: 'light-primary',
		type: 'button',
		onClick: onClear,
		column: 1,
	},
	{
		label: 'Buscar',
		name: 'Buscar',
		color: 'info',
		type: 'button',
		column: 1,
		onClick: onConfirmFilter,
	},
];

export const defaultBody = {
	nombreOrganizacion: '',
};

export const newBodyForm = [
	{
		label: 'Nombre de la organización',
		name: 'nombreOrganizacion',
		type: 'text',
	},
];

export const editForm = [
	{
		label: 'Nombre de la organización',
		name: 'nombre',
		type: 'text',
	},
	{
		label: 'Prefijo',
		name: 'prefijo',
		type: 'text',
	},
];
